import React from "react";
import "../App.css";
import "./hero.css";
import Hero_Img1 from "../images/blob-haikei (2).png";
function HeroSection() {
  return (
    <div className="hero-container">
      <div className="hero_img_container">
        <img src={Hero_Img1} className="hero_img_left" alt="Hero img" />
      </div>
      <h1>The White Dental</h1>
      <p>We Care For You</p>
    </div>
  );
}

export default HeroSection;
